module.exports = __webpack_public_path__ + "static/media/diapersWipes.b8dc5ea7.webp";